

<p-confirmDialog />

<div class="change-log-container">
  <div class="change-log-header">
    <h3 class="m-0">Change Log</h3>
    <p-button
      label="Add"
      icon="pi pi-plus"
      (onClick)="showAddItemDialog()"
      severity="info"
      [rounded]="true" />
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="items"
    [loading]="loading"
    [paginator]="items.length > 10"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 20, 50]"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both change-log-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 100px; text-align: center;">
          CR No
        </th>
        <th class="col-status">Date Requested</th>
        <th>Change Description</th>
        <th style="width: 100px">Priority</th>
        <th class="col-status">Status</th>
        <th style="width: 150px">Effort Estimate (Days)</th>
        <th class="col-status">Planned Date</th>
        <th class="col-status">Actual Date</th>
        <th>Comments</th>
        <th class="th-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="text-align: center;">
            {{ item.crNumber }}
        </td>
        <td>{{ formatDate(item.dateRequested) }}</td>
        <td class="td-truncate" [pTooltip]="item.changeDescription || '-'" tooltipPosition="top">{{ item.changeDescription || '-' }}</td>
        <td>
          <p-tag
            [value]="item.priority"
            [severity]="getPrioritySeverity(item.priority)" />
        </td>
        <td>
          <p-tag
            [value]="item.status"
            [severity]="getStatusSeverity(item.status)" />
        </td>
        <td>{{ item.effortEstimateDays ?? '-' }}</td>
        <td>{{ formatDate(item.plannedDate) }}</td>
        <td>{{ formatDate(item.actualDate) }}</td>
        <td class="td-truncate" [pTooltip]="item.comments || '-'" tooltipPosition="top">{{ item.comments || '-' }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button icon="pi pi-trash" (onClick)="deleteItem(item)" [text]="true" severity="danger" size="small"
              pTooltip="Delete" tooltipPosition="top" />
            <p-button icon="pi pi-pencil" (onClick)="showEditItemDialog(item)" [text]="true" severity="info" size="small"
              pTooltip="Edit" tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="10" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No change log items found</p>
            <p class="empty-description">Click "Add" to create a new change log item</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Item Dialog -->
<p-dialog
  [visible]="displayItemDialog"
  (visibleChange)="displayItemDialog = $event"
  [header]="isEditItemMode ? 'Edit Change Log Item' : 'Add Change Log Item'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">
  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedItem">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="crNumber">CR No <span class="required-star">*</span></label>
          <input pInputText id="crNumber" [(ngModel)]="selectedItem.crNumber" placeholder="Enter CR number" required />
        </div>
        <div class="field">
          <label for="priority">Priority <span class="required-star">*</span></label>
          <p-select id="priority" [(ngModel)]="selectedItem.priority" [options]="priorityOptions"
            optionLabel="label" optionValue="value" placeholder="Select priority"
            panelStyleClass="filter-dropdown-panel" appendTo="body"
            [ngClass]="'priority-' + getPrioritySeverity(selectedItem.priority || '')">
            <ng-template let-option pTemplate="item">
              <div class="dropdown-item-content">
                <span class="priority-badge" [ngClass]="'priority-' + getPrioritySeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              <div class="dropdown-selected-content">
                <span class="priority-badge" [ngClass]="'priority-' + getPrioritySeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="status">Status <span class="required-star">*</span></label>
          <p-select id="status" [(ngModel)]="selectedItem.status" [options]="statusOptions"
            optionLabel="label" optionValue="value" placeholder="Select status"
            panelStyleClass="filter-dropdown-panel" appendTo="body"
            [ngClass]="'status-' + getStatusSeverity(selectedItem.status || '')">
            <ng-template let-option pTemplate="item">
              <div class="dropdown-item-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              <div class="dropdown-selected-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
        <div class="field">
          <label for="effortEstimateDays">Effort Estimate (Days)</label>
          <p-inputnumber id="effortEstimateDays" [(ngModel)]="selectedItem.effortEstimateDays" [min]="0"
            [maxFractionDigits]="2" placeholder="Enter effort estimate" [showButtons]="true" />
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="dateRequested">Date Requested <span class="required-star">*</span></label>
          <p-datepicker id="dateRequested" [(ngModel)]="dateRequested" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" required />
        </div>
        <div class="field">
          <label for="plannedDate">Planned Date</label>
          <p-datepicker id="plannedDate" [(ngModel)]="plannedDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="actualDate">Actual Date</label>
          <p-datepicker id="actualDate" [(ngModel)]="actualDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['changeDescription'] && !selectedItem.changeDescription.trim()">
          <label for="changeDescription">Change Description <span class="required-star">*</span></label>
          <textarea pInputText id="changeDescription" [(ngModel)]="selectedItem.changeDescription" rows="3"
            placeholder="Enter change description..." required class="p-inputtext" (blur)="fieldTouched['changeDescription'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['changeDescription'] && !selectedItem.changeDescription.trim()">Change description is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="comments">Comments</label>
          <textarea pInputText id="comments" [(ngModel)]="selectedItem.comments" rows="3" placeholder="Enter comments..." class="p-inputtext"></textarea>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetItemForm()" [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="displayItemDialog = false" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveItem()" severity="primary"
        [disabled]="!selectedItem || !selectedItem.changeDescription.trim() || !selectedItem.crNumber.trim()" />
    </div>
  </ng-template>
</p-dialog>

